import { Badge, Space, Tag, Typography } from "antd"
import { useTranslation } from "react-i18next"

const { Text } = Typography

// The Result pill: the platform's status chip (hairline border, coloured dot), green Matched and
// orange No match, the same orange as the flow's No match node (RCA-11-07, RCA-7-04). A failed
// lookup found no order either, so it reads No match, as it does in the flow. Shared by the
// Recent lookups table and its phone cards.
const ResultTag = ({ value }) => {
  const { t } = useTranslation()

  if (!value) return "—"

  const matched = value === "matched"
  const status = matched ? "success" : "warning"

  return (
    <Tag color={status} className="simple large" style={{ margin: 0 }}>
      <Space>
        <Badge status={status} />
        <Text>{t(matched ? "Matched" : "No match")}</Text>
      </Space>
    </Tag>
  )
}

export default ResultTag
